import type { components } from '@/api/schema'

const errorMessages: Record<
  NonNullable<components['schemas']['ClassificationResult']['error']>,
  string
> = {
  invalid_config: 'Review your instructions and permissions, then save again.',
  payload_too_large:
    'This message and its instructions exceed the request size limit.',
  context_exceeded:
    'This message is too long to process. Choose another message.',
  missing_credentials:
    'Email processing is not available yet. Try again later.',
  quota_exceeded:
    'Your processing limit has been reached. Check your plan or try again later.',
  price_unavailable:
    'Email processing is temporarily unavailable. Try again later.',
  provider_unavailable: 'Email processing is unavailable. Try again later.',
  invalid_response: 'The service could not return a usable answer. Try again.',
  timeout: 'Processing took too long. Try again.',
}

export function ClassificationResultView({
  result,
}: {
  result: components['schemas']['ClassificationResult']
}) {
  if (!result.error) return null
  return (
    <p role="alert" className="text-sm text-destructive">
      {errorMessages[result.error]}
    </p>
  )
}
